// extracted by mini-css-extract-plugin
export default {"container":"quicksight_container__o5d6b","iframe":"quicksight_iframe__1YPRz","select":"quicksight_select__guzVn"};